import React from "react";
import axios from "axios";
import { setup as URI_SETUP, host as HOST } from "../../../../../config/api";
import { Steps, Button, Icon, Modal, message, Form, Switch, Slider, InputNumber, Table, Input, Select, notification } from 'antd';
import {tblColsNewBudget, monthByNumber} from "../../../../../config/Helpers";

const Step = Steps.Step;
const { TextArea } = Input;
const { Option } = Select;
const ButtonGroup = Button.Group;
const uri_budget = URI_SETUP+"budget";

const budgetSteps = [{
    title: 'Define',
    content: 'define',
  }, {
    title: 'Fill',
    content: 'fill',
  } /*, {
    title: 'Activate',
    content: 'activate',
  } */ ];

class BudgetNew extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            current                   : 0,
            reference_years           : [],
            budget_years              : [],
            budget_periods            : [{
                                          key: 'year',
                                          title: 'Year',
                                          table_width: 400
                                        }, {
                                          key: 'month',
                                          title: 'Month',
                                          table_width: 1640
                                        } , {
                                          key: 'day',
                                          title: 'Day',
                                          table_width: 4540
                                        } ], 
            budget_depths            : [/* {
                                          key: 'global',
                                          title: 'Global',
                                        }, */{
                                          key: 'segment',
                                          title: 'Segment',
                                        }, {
                                          key: 'agency',
                                          title: 'Agency',
                                        }],
            budget_bys            : [{
                                          key: 'amount',
                                          title: 'Amount',
                                        }, /* {
                                          key: 'percent',
                                          title: 'Percent',
                                        } */],
            input_value_active        : "adr",
            budget_matrix_maped       : [],
            sts_budget_edit_box       : "arrows-alt",
            is_loading_matrix_table   : true,
            values_by_room            : false, 
            apply_growth              : false,      
            active_budget             : {
                                        period              : "",
                                        year                : 0,
                                        reference_year      : 0,
                                        depth               : "",
                                        capture_format      : "",
                                        expected_growth     : 0,
                                        growth              : 0,
                                        matrix              : [],
                                        status              : "draft",
                                        short_description   : "",
                                        details             : "",
                                      },
            active_matrix                 : [],
            saved_values                  : [],
            reference_values              : [],
            updated_values                : [],
            details                       : "",
            active_month                  : 1,
            modal_set_live                : false,
            importation_modal             : false,
            dbfile                        : '',
            file_name                     : 'CHOOSE FILE'
            }
    }

    componentWillMount(){
        this.getAvailableYears();
        //this.mapBudgetMatrixRows();
        if(this.props.active_budget._id!=undefined){
          this.getFullBudgetDetails(this.props.active_budget._id);
                  
          if(this.state.current<1){
            this.setState({ current : 1 })
          }
          
        }
    } 

    componentDidUpdate(prevProps, prevState) {
      
      if (prevState.active_budget != this.state.active_budget) {
          
        if(this.state.active_budget.matrix!=[]){
            this.mapBudgetMatrixRows();
          }
      }

      if (prevState.active_month != this.state.active_month) {
        this.mapBudgetMatrixRows(this.state.input_value_active);
        this.setState({
          is_loading_matrix_table : false
        });
      }

      if( prevState.updated_values != this.state.updated_values ){
        if(this.state.updated_values!=undefined){
          var self = this;
          let saved_values = self.state.saved_values;
          let updated_values = self.state.updated_values;
          Object.keys(updated_values).map(function(row, i){
            
            Object.keys(updated_values[row]).map(function(row2, i){ 
              if(saved_values[row]!=undefined){
                saved_values[row][row2] = updated_values[row][row2];
              }else{
                saved_values[row] = updated_values[row];
              }
            });
          });
          this.setState({ saved_values });
          this.mapBudgetMatrixRows(this.state.input_value_active);
        }
          
      }
        
    }

    // ----------------------- Handlers -----------------------

    handleSetLiveItem(_id) {
      let self = this;
      self.setState({ 
          modal_set_live    : true  
          })  
    }

    handleImportModal() {
      let self = this;
      self.setState({ 
          importation_modal    : true  
          })  
    }

    handleCancelSetLive = e => {
      this.setState({
          modal_set_live        : false,
      });
    };

    handleConfirmSetLive = e => {
      let formData = new FormData();

      notification.open({
        message: 'Notification',
        description: "Now Magnum going to process this data to set it up as a live Budget, this process could take several minutes."
      });

      formData.append('api_token',localStorage.getItem("api_token"));
      formData.append('mode',"set_as_visible");
      
      axios.post(uri_budget+"/"+this.props.active_budget._id, formData)
                  .then(request => { 
                    notification.open({
                      message: request.data.result.type,
                      description: request.data.result.message
                    });
                  })
                  .catch(error => {
                      notification.open({
                          message: 'Unsuccessful',
                          description: "Process Unsuccessful please try again"
                        });
                  });
      this.setState({
          modal_set_live        : false,
      });
      
    };
    
    handleMonthChange(active_month) {
      let self = this;
      self.setState({ 
          active_month  
          }) 
    }

    handleValuesByRoom(checked) {
      let self = this;
      self.setState({ 
          values_by_room : checked  
          })
    }

    handleApplyPercentage(checked) {
      let self = this;
      self.setState({ 
          apply_growth : checked  
          })
    }

    handleActivateBudget(checked) {
      let self = this;
      
    }

    handleBudgetInfoInput(e){
        const target = e.target;
        const name = target.name;
        const value = target.value;
        let active_budget = this.state.active_budget;
        active_budget[name] = value;
        this.setState({
            active_budget
        });
    }
    
    handleBudgetEditBoxStatus(){
      let sts_budget_edit_box = this.state.sts_budget_edit_box;
      if(sts_budget_edit_box=="arrows-alt"){
        sts_budget_edit_box="shrink";
      }else{
        sts_budget_edit_box="arrows-alt";
      }
      this.setState({ sts_budget_edit_box });
    }
    
    handleActiveBudget = (e) => {
        let active_budget = Object.assign({}, this.state.active_budget);
        active_budget[e.target.name] = e.target.value;
        this.setState({  active_budget }); 
    }
    
    handlePercentageGrowth = (value) => {
        let active_budget = Object.assign({}, this.state.active_budget);
        active_budget.expected_growth = Number(value);
        this.setState({  active_budget }); 
    }

    handleValueActive (input_value_active) {
      this.setState({ 
        input_value_active : input_value_active
      })
      this.mapBudgetMatrixRows(input_value_active);
    }

    handleFileSelector(e) {
      if(e[0] != undefined){
          this.setState({ 
              dbfile      : e[0],
              file_name   : e[0].name
              })
      }
    }

    handleInputMatrixBlur = (e) => {
      let self = this;
      let active_matrix = Object.assign({}, self.state.active_matrix);
      let values = [];
      let row = e.target.getAttribute('data-row');
      let col = e.target.getAttribute('data-col');
      let type = self.state.input_value_active;
      let row_agency=(e.target.getAttribute('data-row-agency')!=undefined)? e.target.getAttribute('data-row-agency') : null ;
      var qs = require("qs");
      
      values['type'] = type;
      values['budget_id'] = self.state.active_budget._id;
      values['budget_status'] = self.state.active_budget.status;
      values['col'] = col;
      values['mode'] = "update_input"; 
      values['value'] = Number(e.target.value);
      values["api_token"]=localStorage.getItem("api_token");

      if(row_agency==null){
          values['_id'] = active_matrix[row]._id;
          values['name'] = active_matrix[row].name;
        
      }else{
        values['segment_id'] = active_matrix[row]._id;
        values['segment_name'] = active_matrix[row].name;
        values['_id'] = active_matrix[row].agencies[row_agency]._id;
        values['name'] = active_matrix[row].agencies[row_agency].name;
      }
      const itemToSent = qs.stringify(values);

      axios.post(uri_budget+"/"+self.state.active_budget._id, itemToSent)
          .then(request => { 
              self.setState({ 
                updated_values         : request.data,
              }); 
          });
    }

    // ----------------------- Functions -----------------------

    gridGralTotalizer(grid, capture_format){
      let totals = {
                    'adr'     : 0,
                    'nights'  : 0,
                    'revenue' : 0
                  };
      grid.map(function(row, i){
        Object.keys(row.cols).map(function(row_cols, j){

            if(capture_format=='amount'){
              totals.adr = Number(totals.adr) + Number(row.cols[row_cols].adr.value);
              totals.nights = Number(totals.nights) + Number(row.cols[row_cols].nights.value);
              totals.revenue = Number(totals.revenue) + Number(row.cols[row_cols].revenue.value);
            }else{
              totals.adr = Number(totals.adr) + ( Number(row.cols[row_cols].adr.ref) + ( (Number(row.cols[row_cols].adr.value) /100) * Number(row.cols[row_cols].adr.ref) ) );
              totals.nights = Number(totals.nights) + ( Number(row.cols[row_cols].nights.ref) + ( (Number(row.cols[row_cols].nights.value) /100) * Number(row.cols[row_cols].nights.ref) ) );
              totals.revenue = Number(totals.revenue) + ( Number(row.cols[row_cols].revenue.ref) + ( (Number(row.cols[row_cols].revenue.value) /100) * Number(row.cols[row_cols].revenue.ref) ) );
            }
            
        });
      }); 
      return totals;

    }
    
    getFullBudgetDetails(id){
        this.setState({ is_loading_matrix_table    : true});
        let self = this;
        axios.get(uri_budget+"/"+id, { 
            params: {
                api_token       : localStorage.getItem("api_token")
            }
        }).then(request => { 
            self.setState({ 
                active_budget                  : request.data.budget,
                active_matrix                  : request.data.matrix,
                saved_values                   : request.data.saved_values,
                reference_values               : request.data.reference_values,
                is_loading_matrix_table        : false
            }) 
        })
    }

    saveBudget(active_budget=null){
      let self = this;
      var qs = require("qs");
      
      active_budget = (active_budget!=null)? active_budget : Object.assign({}, this.state.active_budget);

      active_budget["property_id"] = self.props.hotel_selected;
      active_budget["api_token"]=localStorage.getItem("api_token");
      active_budget["values_by_room"] = self.state.values_by_room;
      active_budget["apply_growth"] = self.state.apply_growth;
      const itemToSent = qs.stringify(active_budget);

      if(active_budget._id==undefined){
          axios.post(uri_budget, itemToSent)
                  .then(request => { 
                    self.setState({ 
                      active_budget   : request.data.budget,
                      active_matrix       : request.data.matrix,
                      saved_values        : request.data.saved_values,
                      reference_values    : request.data.reference_values
                    });
                  })
      }else{
          axios.post(uri_budget+"/"+active_budget._id, itemToSent)
          .then(request => { 
            self.setState({ 
              active_budget              : request.data
            });
          })

      }
      
    }
    
    mapBudgetMatrixRows(input_value_active=null){
      this.setState({ is_loading_matrix_table    : true});
      let maped_rows=[];
      let maped_child_rows=[];
      let maped_child_row={};
      let maped_row={};
      let self=this;
      input_value_active = (input_value_active==null)? self.state.input_value_active : input_value_active;
      let limit = 1;
      switch(self.state.active_budget.period){
        case 'month': limit = 12; break;
        case 'day': limit = new Date(self.state.active_budget.year, self.state.active_month, 0).getDate(); break;
      }
      let saved = self.state.saved_values;
      let reference = self.state.reference_values;
      if(self.state.active_budget!=undefined){
        switch(self.state.active_budget.depth){
          case "agency":
              self.state.active_matrix.map(function(row, i){
                maped_row={};
                maped_row[self.state.active_budget.depth]=row.name;
                maped_row["key"]=self.state.active_budget.depth+"row"+i;
                
                for(let row_cols=1 ; row_cols<= limit; row_cols++){
                  let row_ext=(self.state.active_budget.period=='day')?self.state.active_month+"_"+row_cols : row_cols;
                  let show_subtotal = (saved[row._id]==undefined)? false : ((saved[row._id][row_ext]==undefined)? false : ((saved[row._id][row_ext][input_value_active]==undefined)? false : true)); 
                  let show_subtotal_ref = (reference[row._id]==undefined)? false : ((reference[row._id][row_ext]==undefined)? false : ((reference[row._id][row_ext][input_value_active]==undefined)? false : true)); 
                  let growth_subtotal_str = "same";
                      if(show_subtotal){
                        if(show_subtotal_ref){
                          growth_subtotal_str = (saved[row._id][row_ext][input_value_active] == reference[row._id][row_ext][input_value_active])? "same" : (saved[row._id][row_ext][input_value_active] < reference[row._id][row_ext][input_value_active])? "down" : "up";
                        }else{
                          growth_subtotal_str = (saved[row._id][row_ext][input_value_active] < 0)? "down" : "up";
                        }
                      }else{
                        if(show_subtotal_ref){
                          growth_subtotal_str = (reference[row._id][row_ext][input_value_active]==0)? "same" : "down";
                        }
                      }
                  
                  maped_row[self.state.active_budget.depth+row_ext]=
                      <div className="cell-with-input">
                        <div className="cell-subtotal"> {(show_subtotal)? saved[row._id][row_ext][input_value_active].toLocaleString() : 0 } <span> {(show_subtotal_ref)? reference[row._id][row_ext][input_value_active].toLocaleString(): 0 } </span> </div>
                        <div className={"cell-diff diff-subtotal " + growth_subtotal_str }> 
                                {(!(show_subtotal_ref && show_subtotal) ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(saved[row._id][row_ext][input_value_active])/Number(reference[row._id][row_ext][input_value_active])) *100)-100).toFixed(0) : saved[row._id][row_ext][input_value_active] ) + "%" ) } 
                        </div>
                      </div>;
                }
                maped_child_rows=[];
                if(row.agencies!=undefined){  
                  row.agencies.map(function(row_agency, k){
                      
                      maped_child_row={};
                      maped_child_row[self.state.active_budget.depth]=row_agency.name;
                      maped_child_row["key"]=self.state.active_budget.depth+"row_agency"+i+"_"+k;
                      
                      for(let row_agency_cols=1 ; row_agency_cols<= limit; row_agency_cols++){
                        let row_agency_ext=(self.state.active_budget.period=='day')?self.state.active_month+"_"+row_agency_cols : row_agency_cols;
                        let show_value = (saved[row_agency._id]==undefined)? false : ((saved[row_agency._id][row_agency_ext]==undefined)? false : ((saved[row_agency._id][row_agency_ext][input_value_active]==undefined)? false : true)); 
                        let show_ref = (reference[row_agency._id]==undefined)? false : ((reference[row_agency._id][row_agency_ext]==undefined)? false : ((reference[row_agency._id][row_agency_ext][input_value_active]==undefined)? false : true)); 
                        let growth_str = "same";
                        if(show_value){
                          if(show_ref){
                            growth_str = (saved[row_agency._id][row_agency_ext][input_value_active] == reference[row_agency._id][row_agency_ext][input_value_active])? "same" : (saved[row_agency._id][row_agency_ext][input_value_active] < reference[row_agency._id][row_agency_ext][input_value_active])? "down" : "up";
                          }else{
                            growth_str = (saved[row_agency._id][row_agency_ext][input_value_active] < 0)? "down" : "up";
                          }
                        }else{
                          if(show_ref){
                            growth_str = (reference[row_agency._id][row_agency_ext][input_value_active]==0)? "same" : "down";
                          }
                        }

                        maped_child_row[self.state.active_budget.depth+row_agency_ext]= <div>
                              {  (input_value_active=='nights') &&  
                                <div className="cell-with-input">
                                  <input 
                                    defaultValue={(show_value)? saved[row_agency._id][row_agency_ext][input_value_active] : 0 } type="number" 
                                    onBlur={self.handleInputMatrixBlur.bind(self)}
                                    data-col={row_agency_ext} data-row={i} data-row-agency={k}
                                    onFocus={e => e.target.select()} 
                                  />
                                  <div className={"cell-diff " + growth_str }> 
                                          {(!(show_ref && show_value) ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(saved[row_agency._id][row_agency_ext][input_value_active])/Number(reference[row_agency._id][row_agency_ext][input_value_active])) *100)-100).toFixed(0) : saved[row_agency._id][row_agency_ext][input_value_active] ) + "%" ) } 
                                  </div>
                                  <div> {(!show_ref ? "N/A" : reference[row_agency._id][row_agency_ext][input_value_active].toFixed(0)) } </div>
                                </div> 
                              }
                              { (input_value_active=='revenue') &&
                                <div className="cell-with-input">
                                  <input 
                                    defaultValue={(show_value)? saved[row_agency._id][row_agency_ext][input_value_active] : 0 } type="number" 
                                    onBlur={self.handleInputMatrixBlur.bind(self)}
                                    data-col={row_agency_ext} data-row={i} data-row-agency={k}
                                    onFocus={e => e.target.select()} 
                                    disabled
                                  />
                                  <div className={"cell-diff " + growth_str }> 
                                          {(!(show_ref && show_value)  ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(saved[row_agency._id][row_agency_ext][input_value_active])/Number(reference[row_agency._id][row_agency_ext][input_value_active])) *100)-100).toFixed(0) : saved[row_agency._id][row_agency_ext][input_value_active] ) + "%" ) } 
                                  </div>
                                  <div> {(!show_ref ? "N/A" : reference[row_agency._id][row_agency_ext][input_value_active].toLocaleString() ) } </div>
                                </div> 
                              }  
                              { (input_value_active=='adr') &&
                                <div className="cell-with-input">
                                  <input 
                                    defaultValue={(show_value)? saved[row_agency._id][row_agency_ext][input_value_active] : 0 } type="number" 
                                    onBlur={self.handleInputMatrixBlur.bind(self)}
                                    data-col={row_agency_ext} data-row={i} data-row-agency={k}
                                    onFocus={e => e.target.select()} 
                                  />
                                  <div className={"cell-diff " + growth_str }> 
                                          {(!(show_ref && show_value) ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(saved[row_agency._id][row_agency_ext][input_value_active])/Number(reference[row_agency._id][row_agency_ext][input_value_active])) *100)-100).toFixed(0) : saved[row_agency._id][row_agency_ext][input_value_active] ) + "%" ) } 
                                  </div>
                                  <div> {(!show_ref ? "N/A" : reference[row_agency._id][row_agency_ext][input_value_active].toLocaleString()) } </div>
                                </div>  
                              }  
                              </div>;
                      }
                      maped_child_rows.push(maped_child_row);
                  });
                  maped_row["children"]=maped_child_rows;
                }

                maped_rows.push(maped_row);
                maped_row={};
                

              });
            break;
          default: 
              self.state.active_matrix.map(function(row, i){
                maped_row={};
                maped_row[self.state.active_budget.depth]=row.name;
                maped_row["key"]=self.state.active_budget.depth+"row"+i;
                let saved = self.state.saved_values;
                let reference = self.state.reference_values;
                for(let row_cols=1 ; row_cols<= limit; row_cols++){
                  let row_ext=(self.state.active_budget.period=='day')?self.state.active_month+"_"+row_cols : row_cols;
                  let show_value = (saved[row._id]==undefined)? false : ((saved[row._id][row_cols]==undefined)? false : ((saved[row._id][row_cols][input_value_active]==undefined)? false : true)); 
                  let show_ref = (reference[row._id]==undefined)? false : ((reference[row._id][row_ext]==undefined)? false : ((reference[row._id][row_ext][input_value_active]==undefined)? false : true)); 
                  let growth_str = "same";
                  if(show_value){
                    if(show_ref){
                      growth_str = (saved[row._id][row_ext][input_value_active] == reference[row._id][row_ext][input_value_active])? "same" : (saved[row._id][row_ext][input_value_active] < reference[row._id][row_ext][input_value_active])? "down" : "up";
                    }else{
                      growth_str = (saved[row._id][row_ext][input_value_active] < 0)? "down" : "up";
                    }
                  }else{
                    if(show_ref){
                      growth_str = (reference[row._id][row_ext][input_value_active]==0)? "same" : "down";
                    }
                  }
                  maped_row[self.state.active_budget.depth+row_cols]=<div>
                      {  (input_value_active=='nights') &&  
                          <div className="cell-with-input">
                            <input 
                              defaultValue={(show_value)? saved[row._id][row_ext][input_value_active] : 0 } type="number" 
                              onBlur={self.handleInputMatrixBlur.bind(self)}
                              data-col={row_ext} data-row={i}
                              onFocus={e => e.target.select()} 
                            />
                            <div className={"cell-diff " + growth_str }> 
                                    {(!(show_ref && show_value) ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(saved[row._id][row_ext][input_value_active])/Number(reference[row._id][row_ext][input_value_active])) *100)-100).toFixed(0) : saved[row._id][row_ext][input_value_active] ) + "%" ) } 
                            </div>
                            <div> {(!show_ref ? "N/A" : reference[row._id][row_ext][input_value_active].toFixed(0)) } </div>
                          </div> 
                        }
                        { (input_value_active=='revenue') &&
                          <div className="cell-with-input">
                            <input 
                              defaultValue={(show_value)? saved[row._id][row_ext][input_value_active] : 0 } type="number" 
                              onBlur={self.handleInputMatrixBlur.bind(self)}
                              data-col={row_ext} data-row={i}
                              onFocus={e => e.target.select()} 
                              disabled
                            />
                            <div className={"cell-diff " + growth_str }> 
                                    {(!(show_ref && show_value)  ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(saved[row._id][row_ext][input_value_active])/Number(reference[row._id][row_ext][input_value_active])) *100)-100).toFixed(0) : saved[row._id][row_ext][input_value_active] ) + "%" ) } 
                            </div>
                            <div> {(!show_ref ? "N/A" : reference[row._id][row_ext][input_value_active].toLocaleString() ) } </div>
                          </div> 
                        }  
                        { (input_value_active=='adr') &&
                          <div className="cell-with-input">
                            <input 
                              defaultValue={(show_value)? saved[row._id][row_ext][input_value_active] : 0 } type="number" 
                              onBlur={self.handleInputMatrixBlur.bind(self)}
                              data-col={row_ext} data-row={i} 
                              onFocus={e => e.target.select()} 
                            />
                            <div className={"cell-diff " + growth_str }> 
                                    {(!(show_ref && show_value) ? "N/A" : ( self.state.active_budget.capture_format=='amount' ? (((Number(saved[row._id][row_ext][input_value_active])/Number(reference[row._id][row_ext][input_value_active])) *100)-100).toFixed(0) : saved[row._id][row_ext][input_value_active] ) + "%" ) } 
                            </div>
                            <div> {(!show_ref ? "N/A" : reference[row._id][row_ext][input_value_active].toLocaleString()) } </div>
                          </div>  
                        }
                    </div>;
                }
                maped_rows.push(maped_row);

              });
            break;
        }

        this.setState({ 
          budget_matrix_maped    : maped_rows,
          is_loading_matrix_table    : false
        });

      }

  }

    getAvailableYears(){
        let actual_year = new Date().getFullYear();
        let budget_years = [];
        for (let i = (actual_year-1); i < (actual_year+2); i++) {
            budget_years.push({
                year            : i,
                status          : ""
            });
        }
        this.setState({ 
            budget_years    : budget_years
        })        
    }
    
    next() {
      
      let active_budget = Object.assign({}, this.state.active_budget);
      let msg = {};
      msg = { 
        title               : "BUDGET",
        msg                 : "Annual budget draft successfully saved",
        day                 : "Now",
        progress            : 0,
        datetime            : Date.now()
        }
      
      let current = this.state.current;
      switch(current){
        case 0 : 
        console.log(active_budget);
          if(active_budget.period!='' && active_budget.year!=0 && active_budget.depth!='' && active_budget.capture_format!='' ){
            if(active_budget._id==undefined){
             this.saveBudget(active_budget);
            }
            current++;
          } else{
            notification.open({
              message: 'Alert',
              description: "Some information is missing please review the Budget setup form"
            });
          }

        break;
        default:
          current++;

      }

      this.setState({ current });

      }
    
      prev() {
        const current = this.state.current - 1;
        this.setState({ current });
      }

      cancel(){
        this.props.resetActiveBudget();
        this.props.setActiveBudgetSection("budget-list");
      }

      cancelManualImportation(){
        let self = this;
        self.setState({ 
            importation_modal       : false,
            dbfile                  : "",
            file_name               : "CHOOSE FILE"
            })
      }

      onSubmitImportation(e){
        let self = this;   
        e.preventDefault();
        if(this.state.dbfile!=''){
            let formData = new FormData();
            formData.append('dbfile', self.state.dbfile);
            formData.append('mode', "upload");
            formData.append('api_token', localStorage.getItem("api_token"));

            self.setState({ 
                importation_modal            : false,
                });

            notification.open({
                message: "IMPORTATION",
                description: "Uploading file to Magnum Leap",
                });
            
            axios.post(uri_budget+"/"+this.state.active_budget._id+"/csvmanager", formData)
                    .then(request => { 
                        
                        notification.open({
                            message: request.data.result.type,
                            description: request.data.result.message,
                        });
                        
                        self.getFullBudgetDetails(self.props.active_budget._id);
                        
                    }) 
            
        }
          
      }

    // ----------------------- Renders -----------------------

    renderConfirmSetLive() {
      return (
          <Modal
            title="Confirm Budget Update"
            visible={this.state.modal_set_live}
            onOk={this.handleConfirmSetLive}
            onCancel={this.handleCancelSetLive}
          >
            <p>Are you sure?. If you confirm, the selected data going to replace the actual one.</p>
          </Modal>
      );
    }
    
    renderSteps(content){
      switch (content){
        case "define":
            return(
              <Form >
                <div className="form-row">
                
                  <div className="col col-md-6">
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="period"
                                onChange={this.handleActiveBudget}
                                value={ this.state.active_budget.period }  
                            >
                          <option value="" disabled>Budget Period</option>
                          {Object.keys(this.state.budget_periods).map(item => <option key={item} value={this.state.budget_periods[item].key}>{this.state.budget_periods[item].title }</option>)}
                        </select>
                      </div>  
                    </div>
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="year"
                                onChange={this.handleActiveBudget}
                                value={ this.state.active_budget.year }  
                            >
                            <option value="" disabled>Budget Year</option>
                            { Object.keys(this.state.budget_years).map((key) => {
                                    return( <option key={key} value={this.state.budget_years[key].year} >
                                        {this.state.budget_years[key].year}
                                    </option>);
                                })
                            }
                        </select> 
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="reference_year"
                                onChange={this.handleActiveBudget}
                                value={ this.state.active_budget.reference_year }  
                            >
                              <option value="" disabled>Reference Year</option>
                              <option value={0}>No reference</option>
                              { 
                                (this.state.reference_years!= undefined) &&
                                this.props.app.state.reference_years.map(function(name, index){
                                  return <option key={ index } value={name} >{name}</option>; 
                                })
                              }
                        </select> 
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col col-md-5 align-right">
                          Add values by room
                      </div>
                      <div className="col col-md-1">
                          <Switch  onChange={this.handleValuesByRoom.bind(this)} />
                      </div>
                    </div>

                  </div>
                  <div className="col col-md-6">
                    <div className="form-row">
                      <div className="col col-md-12">
                        <select className="form-control" name="depth"
                                onChange={this.handleActiveBudget}
                                value={ this.state.active_budget.depth }  
                            >
                              <option value="" disabled>Budget Depth</option>
                              {Object.keys(this.state.budget_depths).map(item => <option key={item} value={this.state.budget_depths[item].key}>{this.state.budget_depths[item].title }</option>)}
                        </select> 
                      </div>
                    </div>
                      <section>
                        <div className="form-row">
                          <div className="col col-md-12">
                          
                            <select className="form-control" name="capture_format"
                                    onChange={this.handleActiveBudget}
                                    value={ this.state.active_budget.capture_format }  
                                >
                                  <option value="" disabled>Define Budget by</option>
                                  {Object.keys(this.state.budget_bys).map(item => <option key={item} value={this.state.budget_bys[item].key}>{this.state.budget_bys[item].title}</option>)}
                            </select> 
                          </div>
                        </div>

                        <div className="form-row growth-input">
                          <div className="col col-md-4 lbl-grw-left-alone">
                            Expected <br />Growth (%)
                          </div>
                          <div className="col col-md-4">
                            <Slider
                              min={0}
                              max={100}
                              marks={{0: '0%', 100: '100%'}}
                              onChange={this.handlePercentageGrowth}
                              value={ this.state.active_budget.expected_growth }  
                            />
                          </div>
                          <div className="col col-md-1 percent-input">
                            <InputNumber
                              min={0}
                              max={100}
                              step={1}
                              value={ this.state.active_budget.expected_growth }
                              onChange={this.handlePercentageGrowth}
                            />
                          </div>
                          <div className="col col-md-1 percent-symb">%</div>
                        </div>
                        { /*
                        <div className="form-row">
                          <div className="col col-md-5 align-right">
                              Apply growth to budget
                          </div>
                          <div className="col col-md-2">
                              <Switch onChange={this.handleApplyPercentage} />
                          </div>
                        </div>
                        */ }
                      </section>
                  </div>
                </div>
              </Form>
            );


          break;
        case "fill":
          return(
            <Form >
              <div className="form-row">

                <div className="col col-md-2">
                  Input Values
                </div>
                <div className="col col-md-4">
                <ButtonGroup>
                  <Button className={(this.state.input_value_active=="adr")?"selected":""} onClick={this.handleValueActive.bind(this,"adr")} >ADR</Button>
                  <Button className={(this.state.input_value_active=="nights")?"selected":""} onClick={this.handleValueActive.bind(this,"nights")} >Room Nights</Button>
                  <Button className={"informative " + (this.state.input_value_active=="revenue" ? "selected" : "") } onClick={this.handleValueActive.bind(this,"revenue")} >Revenue</Button>
                </ButtonGroup>
                </div>
                <div className="col col-md-2 budget-details">
                  <h4>Year</h4> 
                  {this.state.active_budget.year}
                  <span className="reference-info">{this.state.active_budget.reference_year}</span>
                </div>
                <div className="col col-md-2 budget-details">
                  <h4>Growth (%)</h4> 
                  {this.state.active_budget.expected_growth}  
                  <div className="reference-info gray">{this.state.active_budget.growth}</div>
                </div>

                { this.state.active_budget.period=="day" &&
                  <div className="col col-md-2 budget-details">
                    <Select defaultValue={1} onChange={this.handleMonthChange.bind(this)}>
                      <Option value={1}>Jan</Option>
                      <Option value={2}>Feb</Option>
                      <Option value={3}>Mar</Option>
                      <Option value={4}>Apr</Option>
                      <Option value={5}>May</Option>
                      <Option value={6}>Jun</Option>
                      <Option value={7}>Jul</Option>
                      <Option value={8}>Aug</Option>
                      <Option value={9}>Sep</Option>
                      <Option value={10}>Oct</Option>
                      <Option value={11}>Nov</Option>
                      <Option value={12}>Dec</Option>                    
                    </Select>
                  </div>
                }
                   
              </div>
              <div className="form-row">
                <div className="col col-md-12">
                  {this.is_loading_matrix_table &&
                    <Icon type="loading" />
                  }
                  { 
                    (this.state.active_budget.year!="" && this.state.active_budget.budget_period!="" && this.state.active_budget.budget_depth!=""  ) && 
                     <Table 
                        columns={tblColsNewBudget(
                                                  this.state.budget_periods.find(period => period.key === this.state.active_budget.period), 
                                                  this.state.budget_depths.find(depth => depth.key === this.state.active_budget.depth), 
                                                  this.state.active_budget.year, this.state.active_month)} 
                        scroll={{ x: this.state.budget_periods.find(period => period.key === this.state.active_budget.period).table_width /*, y : 200 */  }} 
                        dataSource={this.state.budget_matrix_maped}
                        pagination={ true }
                        footer={() => <div className={"row"} >
                                        <a target="_blank" href={ HOST + this.state.active_budget.csv_file } > <Button icon="export" onClick={() => message.success('Processing complete!')}>Export</Button></a>
                                        <Button icon="import"  onClick={this.handleImportModal.bind(this)} >Import</Button>
                                      </div> 
                              }
                        /* loading={this.is_loading_matrix_table} */ />
                  }
                  
                </div>
              </div>
              



            </Form>);         

          break;
        case "activate":
          return(
            <Form >
              <div className="form-row">

                <div className="col col-md-6">  
                  <div className="form-row">
                      <div className="col col-md- 12">
                          <input type="text" className="form-control" name="short_description" placeholder="Short Description" value={this.state.active_budget.short_description} required  onChange={e => this.handleBudgetInfoInput(e)} />          
                      </div>
                  </div>
                  <div className="form-row">
                    <div className="col col-md-10 align-right">
                        Set as active Budget
                    </div>
                    <div className="col col-md-2">
                        <Switch onChange={this.handleActivateBudget} />
                    </div>
                  </div>
                </div>
                <div className="col col-md-6">
                  <div className="form-row">
                      <div className="col col-md-12">
                        <TextArea 
                          rows={4} placeholder="Budget Details" 
                          value={this.state.active_budget.details}
                        />
                      </div>
                  </div>
                </div>

              </div>
            </Form>
          );

          break;
      }
      
    }

    renderImportationModal() {
      return (
          <Modal
            title="Manual Importation"
            visible={this.state.importation_modal}
            onOk={this.onSubmitImportation.bind(this)}
            onCancel={this.cancelManualImportation.bind(this)}
            footer={[
              <Button key="back" onClick={this.cancelManualImportation.bind(this)}>
                Cancel
              </Button>,
              <Button key="submit" type="primary" onClick={this.onSubmitImportation.bind(this)}>
                Import
              </Button>,
            ]}
          >   
              <div className="form-in-box"><form>
                  <div className="form-row importing-csv">
                      <div className="col col-md-9">
                          <button>{this.state.file_name} </button>
                          <input type="file" name="dbfile" onChange={ (e) => this.handleFileSelector(e.target.files) } key={this.state.dbfile || '' } /> 
                      </div>
                  
                      <div className="col col-md-3">
                          <select className="form-control " name="hotel_id" disabled >
                              <option value="csv">.csv</option>
                          </select> 
                      </div>
                  </div>
                </form></div>
              
          </Modal>
      );
      
  }

    render() {
        const { current } = this.state;
        
        return (
          <section>
            <div className={"box regular col-md-12 " +  ( this.state.sts_budget_edit_box=='shrink'? 'maximized' : '' ) } >
              <h3>
                New Budget  
                <Icon className="clickable" type= {this.state.sts_budget_edit_box} onClick={this.handleBudgetEditBoxStatus.bind(this)} />
              </h3>
              <div className="table-in-box"><br />
                <div className="ant-container budget-steps-box">
                  <Steps current={current}>
                    {budgetSteps.map(item => <Step key={item.title} title={item.title} />)}
                  </Steps>
                  <div className="steps-content steps-budget">
                    <div className="form-in-box">
                      {this.renderSteps(budgetSteps[current].content)}
                    </div>
                  </div>
                  <div className="steps-action">
                    { current > 1 &&  (
                      <div className="col col-md-4">
                        <button onClick={() => this.prev()}>
                          Previous
                        </button>
                      </div>
                    )}
                    { current < budgetSteps.length - 1 && 
                      <div className="col col-md-4">
                        <button className="blue" onClick={() => this.next()}>Next</button>
                      </div>
                    }
                    
                    { current === budgetSteps.length - 1 && 
                      <div className="col col-md-4">
                        <button className="blue" onClick={this.handleSetLiveItem.bind(this)} >Set as active Budget</button>
                      </div>
                    }
                    <div className="col col-md-4">
                      <button className="remove" onClick={() => this.cancel()}>
                        Exit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            { this.renderConfirmSetLive() }
            { this.renderImportationModal() }
          </section>
        );

    }

}

export default BudgetNew


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/property/budget/BudgetEdit.js